export default "__VITE_PUBLIC_ASSET__cc871ba3__"